import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-grid-system';
import { prettyMatchUrl } from '../../common/rcs_gaz_mc_core_FE';
import PreferredStar from '../PreferredStar';
import TeamLabel from '../TeamLabel';
import Timing from '../TimeResults/Timing';
import Result from '../TimeResults/Result';
import IconFont from '../../components/shared/IconFont';
import MatchRowScorers from '../../components/MatchRowScorers';
import MatchRowIcon from '../../components/MatchRowIcon';
//import BetBar from '../../components/BetBar';
import { MatchRowWrapper, MatchStatsWrapper } from './styles';
import * as status from '../../constants';
import ConfigManager from '../../common/configManager/configManager';

const MatchRowFav = ({
  matchRow, showRowScorer, actions, dictionary, isMobile, isFav, date, sportId, competitionId,
}) => {
  const handleFavourites = () => {
    if (!showRowScorer) {
      actions.favouriteGame(matchRow.get('matchId'));
      actions.setFavouritesOnCompetition(matchRow.get('matchId'));
    } else {
      actions.removefavouriteGame(sportId, matchRow.get('matchId'), date);
    }
  };

  const awayResPen = (matchRow.getIn(['awayTeam', 'starData', 'shootOuts', 'score'])) ?
    matchRow.getIn(['awayTeam', 'starData', 'shootOuts', 'score']) : 0;
  const homeResPen = (matchRow.getIn(['homeTeam', 'starData', 'shootOuts', 'score'])) ?
    matchRow.getIn(['homeTeam', 'starData', 'shootOuts', 'score']) : 0;

  const isHomeWinner = () => (Number(matchRow.getIn(['homeTeam', 'score'])) + Number(homeResPen))
    > (Number(matchRow.getIn(['awayTeam', 'score']))) + Number(awayResPen) && matchRow.get('status') !== 'LIVE';
  const isAwayWinner = () => (Number(matchRow.getIn(['homeTeam', 'score'])) + Number(homeResPen))
    < (Number(matchRow.getIn(['awayTeam', 'score'])) + Number(awayResPen)) && matchRow.get('status') !== 'LIVE';

  const isLive = () => matchRow.get('status') === 'LIVE';
  const isPreMatch = () => matchRow.get('status') === status.PREMATCH_STATUS;
  const imagesURL = ConfigManager.getFootballTeams('min');

  return (
    <MatchRowWrapper
      href={prettyMatchUrl(matchRow.getIn(['homeTeam', 'teamName']), matchRow.getIn(['awayTeam', 'teamName']), matchRow.get('matchId'), sportId, competitionId, process.env.REACT_APP_SITE)}
      hideMatch={matchRow.get('matchId') === '980149'}
    >
      <Row style={{
        width: '100%', marginRight: '0', marginLeft: '0', alignItems: 'center',
      }}
      >
        <Col
          md={1.1}
          sm={1.1}
          xs={1.1}
          style={{
            paddingRight: '0',
            paddingLeft: '0',
            marginTop: isPreMatch() ? '0px' : '-10px',
          }}
        >
          <PreferredStar handleFavourites={handleFavourites} isSelected={matchRow.get('favourite')} />
        </Col>
        <Col md={4.2} xs={4.1} style={{ paddingRight: '0', paddingLeft: '0', marginTop: isPreMatch() ? '0px' : '-10px' }}>
          <TeamLabel
            label={matchRow.getIn(['homeTeam', 'teamName'])}
            color="black"
            image={`${imagesURL}${matchRow.getIn(['homeTeam', 'teamId'])}.png`}
            marginLeft={0.4}
            font={isHomeWinner() ? 'narrowMedium' : 'narrowRegular'}
          />
        </Col>
        <Col md={1.6} xs={1.8} style={{ paddingRight: '0', paddingLeft: '0', marginTop: '3px' }}>
          {matchRow.get('status') !== status.PREMATCH_STATUS &&
            <Result
              awayRes={matchRow.getIn(['awayTeam', 'score'])}
              homeRes={matchRow.getIn(['homeTeam', 'score'])}
              awayPenRes={awayResPen}
              homePenRes={homeResPen}
              status={matchRow.get('status')}
              isMobile={isMobile}
              isFav={isFav}
            />
          }
          <Timing
            timing={matchRow.get('timing')}
            resultType={matchRow.get('resultType')}
            date={matchRow.get('utcDate')}
            isLive={isLive()}
            dictionary={dictionary}
          />
        </Col>
        <Col md={4.2} xs={4.1} style={{ paddingRight: '0', paddingLeft: '0', marginTop: isPreMatch() ? '0px' : '-10px' }}>
          <TeamLabel
            label={matchRow.getIn(['awayTeam', 'teamName'])}
            color="black"
            image={`${imagesURL}${matchRow.getIn(['awayTeam', 'teamId'])}.png`}
            marginLeft={0.4}
            font={isAwayWinner() ? 'narrowMedium' : 'narrowRegular'}
          />
        </Col>
        <Col
          lg={0.8}
          md={0.8}
          sm={0.8}
          xs={0.8}
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            flexDirection: 'row',
            paddingRight: isMobile ? '5px' : '10px',
            paddingLeft: isMobile ? '0' : '15px',
            marginTop: isMobile ? isPreMatch() ? '0px' : '-10px' : '0px',
          }}
        >
          <IconFont
            className="icon-matchcenter-right-arrow"
            color="selectedColor"
            font={16}
            weight="bold"
            withCursor
          />
        </Col>
      </Row>
      {showRowScorer && matchRow && (
       matchRow.getIn(['homeTeam', 'starData', 'goals']).size > 0 || matchRow.getIn(['awayTeam', 'starData', 'goals']).size > 0) &&
       <Row style={{
        width: '100%', marginRight: '0', marginLeft: '0',
       }}
       >
         <Col md={4.05} sm={4.05} xs={3.95} style={{ padding: '0' }} offset={{ md: 1.2, sm: 1.2, xs: 1.2 }}>
           <MatchRowScorers
             color="gray"
             weight="normal"
             size={0.8}
             scorers={matchRow.getIn(['homeTeam', 'starData', 'goals'])}
             font="narrowRegular"
           />
           {matchRow.getIn(['homeTeam', 'starData', 'shootOuts']) && matchRow.getIn(['homeTeam', 'starData', 'shootOuts', 'penalties']) &&
           <MatchRowScorers
             color="gray"
             weight="normal"
             size={1.5}
             penaltyScorers={matchRow.getIn(['homeTeam', 'starData', 'shootOuts', 'penalties'])}
             font="narrowRegular"
           />
           }
         </Col>
         <Col
           md={1.4}
           sm={1.4}
           xs={1.6}
           style={{
           display: 'flex', justifyContent: 'center', padding: '0', alignItems: 'flex-end',
         }}
         />
         <Col md={4.05} sm={4.05} xs={3.95} style={{ padding: '0' }} offset={{ md: 0.4, sm: 0.4, xs: 0.4 }}>
           <MatchRowScorers
             color="gray"
             weight="normal"
             size={0.8}
             scorers={matchRow.getIn(['awayTeam', 'starData', 'goals'])}
             font="narrowRegular"
           />
           {matchRow.getIn(['awayTeam', 'starData', 'shootOuts']) && matchRow.getIn(['awayTeam', 'starData', 'shootOuts', 'penalties']) &&
           <MatchRowScorers
             color="gray"
             weight="normal"
             size={1.5}
             penaltyScorers={matchRow.getIn(['awayTeam', 'starData', 'shootOuts', 'penalties'])}
             font="narrowRegular"
           />
           }
         </Col>
       </Row>
      }
      {showRowScorer && matchRow && (
        matchRow.getIn(['starData', 'substitutions']) > 0 || matchRow.getIn(['starData', 'yellowBookings']) > 0 || matchRow.getIn(['starData', 'redBookings']) > 0) &&
        <Row style={{
          width: '100%', marginRight: '0', marginLeft: '9px', marginTop: '10px',
        }}
        >
          <Col
            md={12}
            sm={12}
            xs={12}
            style={{
              display: 'flex', justifyContent: 'center', padding: '0', alignItems: 'flex-end',
            }}
          >
            <MatchStatsWrapper isFav={isFav}>
              {matchRow && matchRow.getIn(['starData', 'substitutions']) > 0 &&
              <MatchRowIcon
                matchStats={matchRow.getIn(['starData', 'substitutions'])}
                color="black"
                bg="green"
                size={13}
                className="icon-matchcenter-arrows-circle"
                marginRight={0.2}
                marginLeft={isFav ? 0 : 1}
                font="narrowMedium"
                isSubstitution
              >
                <span className="path1" />
                <span className="path2" />
              </MatchRowIcon>
              }
              {matchRow && matchRow.getIn(['starData', 'redBookings']) > 0 &&
              <MatchRowIcon
                matchStats={matchRow.getIn(['starData', 'redBookings'])}
                color="white"
                bg="red"
                size={13}
                className="icon-matchcenter-rectangle"
                font="narrowMedium"
              />
              }
              {matchRow && matchRow.getIn(['starData', 'yellowBookings']) > 0 &&
              <MatchRowIcon
                matchStats={matchRow.getIn(['starData', 'yellowBookings'])}
                color="black"
                bg="yellow"
                size={13}
                className="icon-matchcenter-rectangle"
                font="narrowMedium"
              />
              }
            </MatchStatsWrapper>
          </Col>
        </Row>
      }
      {/* (matchRow.get('status') !== status.FULL_STATUS || (date !== 'yesterday')) &&
        <BetBar
          isMobile={isMobile}
        />
       */}
    </MatchRowWrapper>
  );
};

MatchRowFav.propTypes = {
  matchRow: PropTypes.any,
  showRowScorer: PropTypes.any,
  actions: PropTypes.any,
  dictionary: PropTypes.any,
  isMobile: PropTypes.bool,
  isFav: PropTypes.bool,
  date: PropTypes.string,
  sportId: PropTypes.string,
  competitionId: PropTypes.any,
};

export default MatchRowFav;
